import { FC } from 'react';
import classNames from 'classnames';

type Props = {
  className?: string;
};

const BeApproachable: FC<Props> = ({ className }) => (
  <svg
    className={classNames('w-[24px] h-[24px] stroke-[1.5px]', className)}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.41016 22.0002C3.41016 18.1302 7.26016 15.0002 12.0002 15.0002M22.0002 22.0002L21.0002 21.0002M12.0002 12.0002C13.3262 12.0002 14.598 11.4735 15.5357 10.5358C16.4734 9.5981 17.0002 8.32633 17.0002 7.00024C17.0002 5.67416 16.4734 4.40239 15.5357 3.46471C14.598 2.52703 13.3262 2.00024 12.0002 2.00024C10.6741 2.00024 9.4023 2.52703 8.46462 3.46471C7.52694 4.40239 7.00016 5.67416 7.00016 7.00024C7.00016 8.32633 7.52694 9.5981 8.46462 10.5358C9.4023 11.4735 10.6741 12.0002 12.0002 12.0002ZM18.2002 21.4002C19.0488 21.4002 19.8628 21.0631 20.4629 20.463C21.063 19.8629 21.4002 19.0489 21.4002 18.2002C21.4002 17.3516 21.063 16.5376 20.4629 15.9375C19.8628 15.3374 19.0488 15.0002 18.2002 15.0002C17.3515 15.0002 16.5375 15.3374 15.9374 15.9375C15.3373 16.5376 15.0002 17.3516 15.0002 18.2002C15.0002 19.0489 15.3373 19.8629 15.9374 20.463C16.5375 21.0631 17.3515 21.4002 18.2002 21.4002Z"
      stroke="currentColor"
      strokeWidth="currentStrokeWidth"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default BeApproachable;
